import React, { useMemo } from 'react';
import { down } from 'static/icons/resizable';
import * as S from './BackTitle.styles';

export type IProps = {
  title?: string;
  description?: string;
  isDescriptionFirst?: boolean;
  onBackAction?: () => void;
};

export const BackTitle = ({
  title,
  description,
  isDescriptionFirst,
  onBackAction,
}: IProps) => {
  const goBack = () => {
    onBackAction && onBackAction();
  };

  const isDiscountInNewTab = useMemo(
    () => window.history.length === 1,
    [window.history.length],
  );

  return (
    <S.BackTitleWrapper data-testid='back-title-wrapper'>
      {!isDiscountInNewTab && (
        <S.BackTitleIcon
          src={down}
          onClick={goBack}
          alt='Go back icon'
          data-testid='back-title-icon'
        />
      )}

      <S.BackTextWrapper data-testid='back-text-wrapper'>
        {isDescriptionFirst ? (
          <>
            {description && (
              <S.BackTitleDescription
                kind='small1'
                color='gray1'
                isDescriptionFirst
                data-testid='back-description'
              >
                {description}
              </S.BackTitleDescription>
            )}
            <S.BackTitleHeader
              kind='h1'
              color='gray1'
              data-testid='back-title-header'
            >
              {title}
            </S.BackTitleHeader>
          </>
        ) : (
          <>
            <S.BackTitleHeader
              kind='h1'
              color='gray1'
              data-testid='back-title-header'
            >
              {title}
            </S.BackTitleHeader>
            {description && (
              <S.BackTitleDescription
                kind='small1'
                color='gray2'
                data-testid='back-description'
              >
                {description}
              </S.BackTitleDescription>
            )}
          </>
        )}
      </S.BackTextWrapper>
    </S.BackTitleWrapper>
  );
};
